import de from './de'
import en from './en'
import fr from './fr'
import es from './es'
import it from './it'

// TODO: Check dynamic import

import deMTF from './mtf/de'
import enMTF from './mtf/en'
import frMTF from './mtf/fr'
import esMTF from './mtf/es'
import itMTF from './mtf/it'

const vendor = process.env.VENDOR || 'resol'

export default {
  de: { translation: vendor === 'mtf' ? deMTF : de },
  en: { translation: vendor === 'mtf' ? enMTF : en },
  fr: { translation: vendor === 'mtf' ? frMTF : fr },
  es: { translation: vendor === 'mtf' ? esMTF : es },
  it: { translation: vendor === 'mtf' ? itMTF : it }
}



// WEBPACK FOOTER //
// ./src/locales/index.js